// react
import React, {
  Fragment,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
// redux
import { useSelector } from "react-redux";
// styles
import styles from "./index.module.scss";
// components
import { Input } from "../../../components/inputs/InputField/index";
import { BtnSmall } from "../../../components/btns/btnSmall/index";
import { StudentItem } from "../../../components/studentsComponents/studentItem/index";
import { NavHeader } from "../../../components/navHeader";
import { Message } from "../../../components/message";
import { FormPopUp } from "../../../components/formPopUp";
// img
import SearchIcon from "../../../assets/icons/search.svg";
// reducer
import {
  dashboardStatesInitialState,
  dashboardStatesReducer,
} from "./indexReducer";
// MUI
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
// services
import {
  getStudentsData,
  searchForStudent,
  downloadStudentData,
  deleteStudentDataService,
} from "../../../services/adminService.js";
import { getFacultiesService } from "../../../services/universityStructureService";
//  get role service
import { getRoleService } from "../../../services/adminService";
// cookies
import Cookies from "js-cookie";
// router
import { useNavigate } from "react-router-dom";

/***************************************************************************/
/* Name : StudentsInfo React Component */
/***************************************************************************/
const StudentsInfo = React.memo(() => {
  const navigate = useNavigate();
  const api_url = useSelector((state) => state.ui.api_url);
  // reducer
  const [dashboardStates, dispatchDashboardStates] = useReducer(
    dashboardStatesReducer,
    dashboardStatesInitialState
  );
  // students data state
  const [studentsData, setStudentsData] = useState([]);
  // faculty selected
  const [facultySelected, setFacultySelected] = useState("اختر الكلية");
  const [facultiesData, setFacultiesData] = useState([]);
  // number of students
  const [numberOfStudents, setNumberOfStudents] = useState(0);
  // number of students completed
  const [numberOfStudentsCompleted, setNumberOfStudentsCompleted] = useState(0);
  //  number of pages
  const [numberOfPages, setNumberOfPages] = useState(10);
  // page selected
  const [pageSelected, setPageSelected] = useState(1);
  // number of students per page
  const [numberOfStudentsPage, setNumberOfStudentsPage] = useState(500);
  // search mode
  const [searchMode, setSearchMode] = useState(false);
  // renderContainer
  const [renderContainer, setRenderContainer] = useState(false);
  // search ref
  const searchRef = useRef(null);
  // role state
  const [role, setRole] = useState("");
  // search type states
  const [searchType, setSearchType] = useState("اخنر نوع البحث");
  // confirm delete form
  const [confirmDeleteForm, setConfirmDeleteForm] = useState(false);
  // student deleted name
  const [studentDeletedObj, setStudentDeletedObj] = useState({
    name: "",
    id: "",
  });
  const [searchTypeData, setSearchTypeData] = useState([
    { value: 1, title: "الاسم" },
    { value: 2, title: "الرقم القومي" },
  ]);
  /******************************************************************/
  /* useEffect */
  /******************************************************************/
  useEffect(() => {
    (async () => {
      // get token
      const token = Cookies.get("token");
      // get role
      const { role } = await getRoleService(token);
      if (role === "SUPERADMIN" || role === "SUPPORT") {
        // get faculties
        await getFacultiesHandler();
      }
      // set role
      if (role !== undefined) {
        setRole(role);
      }
      if (role === "ADMIN") {
        await getStudentsDataHandler(pageSelected);
      }
      // check if token is exist
      if (!token) {
        // redirect to login page
        navigate("/admin/login");
      }
    })();
  }, []);
  /******************************************************************/
  /* delete admin handler */
  /******************************************************************/
  const deleteStudentHandler = async () => {
    // pending
    // delete admin
    const response = await deleteStudentDataService(studentDeletedObj.id);
    if (response.status === "success") {
      // close confirm form
      setConfirmDeleteForm(false);
      // remove student from students data
      const newStudentsData = studentsData.filter(
        (el) => el._id !== studentDeletedObj.id
      );
      // set students data
      setStudentsData(newStudentsData);
    } else {
      dispatchDashboardStates({
        type: "ERROR",
        errorMessage: response.message,
      });
    }
  };
  /******************************************************************/
  /* handleCloseConfirmForm */
  /******************************************************************/
  const handleCloseConfirmForm = () => {
    setConfirmDeleteForm(false);
  };
  /******************************************************************/
  /* get student data */
  /******************************************************************/
  const getStudentsDataHandler = async (page, e) => {
    // set Search mode
    setSearchMode(false);
    // set render container
    setRenderContainer(true);
    // dispatch pending
    dispatchDashboardStates({
      type: "PENDING_LOADING",
    });
    let response;
    if (role === "ADMIN") {
      response = await getStudentsData(
        page ? page : pageSelected,
        numberOfStudentsPage,
        null
      );
    } else {
      response = await getStudentsData(
        page ? page : pageSelected,
        numberOfStudentsPage,
        facultySelected
      );
    }
    if (response.status === "success") {
      dispatchDashboardStates({
        type: "CLEAR",
      });

      // set students data
      setStudentsData(response.data);
      // set number of students
      setNumberOfStudents(response.studentsNumber);
      // set number of students completed
      setNumberOfStudentsCompleted(response.completedStudentsNumber);
      // set number of pages
      setNumberOfPages(
        Math.ceil(response.studentsNumber / numberOfStudentsPage)
      );

      //
    } else {
      dispatchDashboardStates({
        type: "ERROR",
        errorMessage: response.message,
      });
    }
  };
  /******************************************************************/
  /* pagination handler */
  /******************************************************************/
  const paginationHandler = async (e, page) => {
    setPageSelected(page);
    await getStudentsDataHandler(page);
    // go the top of the page
    // window to scroll to y 50 from top
    window.scrollTo(0, 50);
  };
  /******************************************************************/
  /* search for student */
  /******************************************************************/
  const searchForStudentHandler = async (
    isComplete = false,
    filterMode = false
  ) => {
    // get value
    const value = searchRef.current.getInputValue();

    if (!filterMode) {
      // check if value is empty
      if (value.trim() === "") {
        dispatchDashboardStates({
          type: "ERROR",
          errorMessage: "يجب ادخال الاسم او الرقم القومي ",
        });
        return;
      }
      // check if search type is selected
      if (searchType === "اخنر نوع البحث") {
        dispatchDashboardStates({
          type: "ERROR",
          errorMessage: "يجب اختيار نوع البحث",
        });
        return;
      }
    }
    // check if the input is student name
    if (+searchType === 1) {
      dispatchDashboardStates({
        type: "PENDING_LOADING",
      });

      // search for student
      const response = await searchForStudent(
        null,
        value,
        isComplete,
        facultySelected === "اختر الكلية" ? null : facultySelected
      );
      if (response.status === "success") {
        dispatchDashboardStates({
          type: "CLEAR",
        });
        // set students data
        setStudentsData(response.dataArray);
      } else {
        if (response.statusCode == 404) {
          dispatchDashboardStates({
            type: "CLEAR",
          });
          // set students data
          setStudentsData([]);
        } else {
          dispatchDashboardStates({
            type: "ERROR",
            errorMessage: response.message,
          });
        }
      }
      return;
    }
    // check if the input is national id
    if (+searchType === 2) {
      dispatchDashboardStates({
        type: "PENDING_LOADING",
      });

      // search for student
      const response = await searchForStudent(
        value,
        null,
        isComplete,
        facultySelected === "اختر الكلية" ? null : facultySelected
      );
      if (response.status === "success") {
        dispatchDashboardStates({
          type: "CLEAR",
        });
        // set students data
        setStudentsData(response.dataArray);
      } else {
        if (response.statusCode == 404) {
          dispatchDashboardStates({
            type: "CLEAR",
          });
          // set students data
          setStudentsData([]);
        } else {
          dispatchDashboardStates({
            type: "ERROR",
            errorMessage: response.message,
          });
        }
      }
      return;
    }
    // no input
    // pending
    dispatchDashboardStates({
      type: "PENDING_LOADING",
    });

    const response = await searchForStudent(
      null,
      null,
      isComplete,
      facultySelected === "اختر الكلية" ? null : facultySelected
    );
    if (response.status === "success") {
      dispatchDashboardStates({
        type: "CLEAR",
      });
      // set students data
      setStudentsData(response.dataArray);
    } else {
      dispatchDashboardStates({
        type: "ERROR",
        errorMessage: response.message,
      });
    }
  };
  /******************************************************************/
  /* filter is completed */
  /******************************************************************/
  const filterIsCompletedHandler = async (isComplete) => {
    if (!isComplete) {
      // getStudents
      await searchForStudentHandler(false, true);
      return;
    }
    // get value
    const value = searchRef.current.getInputValue();
    // check if the input is student name
    if (+searchType === 1 && value.trim() !== "") {
      dispatchDashboardStates({
        type: "PENDING_LOADING",
      });

      // search for student
      const response = await searchForStudent(
        null,
        value,
        isComplete,
        facultySelected === "اختر الكلية" ? null : facultySelected
      );
      if (response.status === "success") {
        dispatchDashboardStates({
          type: "CLEAR",
        });
        // set students data
        setStudentsData(response.dataArray);
      } else {
        if (response.statusCode == 404) {
          dispatchDashboardStates({
            type: "CLEAR",
          });
          // set students data
          setStudentsData([]);
        } else {
          dispatchDashboardStates({
            type: "ERROR",
            errorMessage: response.message,
          });
        }
      }
      return;
    }
    // check if the input is national id
    if (+searchType === 2 && value.trim() !== "") {
      dispatchDashboardStates({
        type: "PENDING_LOADING",
      });

      // search for student
      const response = await searchForStudent(
        value,
        null,
        isComplete,
        facultySelected === "اختر الكلية" ? null : facultySelected
      );
      if (response.status === "success") {
        dispatchDashboardStates({
          type: "CLEAR",
        });
        // set students data
        setStudentsData(response.dataArray);
      } else {
        if (response.statusCode == 404) {
          dispatchDashboardStates({
            type: "CLEAR",
          });
          // set students data
          setStudentsData([]);
        } else {
          dispatchDashboardStates({
            type: "ERROR",
            errorMessage: response.message,
          });
        }
      }
      return;
    }
    // no input
    dispatchDashboardStates({
      type: "PENDING_LOADING",
    });

    const response = await searchForStudent(
      null,
      null,
      isComplete,
      facultySelected === "اختر الكلية" ? null : facultySelected
    );
    if (response.status === "success") {
      dispatchDashboardStates({
        type: "CLEAR",
      });
      // set students data
      setStudentsData(response.dataArray);
    } else {
      dispatchDashboardStates({
        type: "ERROR",
        errorMessage: response.message,
      });
    }
  };
  /******************************************************************/
  /* export handler */
  /******************************************************************/
  const exportHandler = (complete) => async () => {
    // download students imgs
    dispatchDashboardStates({
      type: "PENDING_PRINTING",
    });
    let response;
    if (role === "ADMIN") {
      response = await downloadStudentData(null, complete);
    } else {
      response = await downloadStudentData(facultySelected, complete);
    }
    // dispatch pending
    if (response.status === "success") {
      dispatchDashboardStates({
        type: "SUCCESS",
        successMessage: "تم تحميل الملف بنجاح",
      });
      // in the response.data there is a url i want to download zip file from
      // i want to navigate to new web page
      window.location.href = `${api_url}/${response.path}`;
    } else {
      dispatchDashboardStates({
        type: "ERROR",
        errorMessage: response.message,
      });
    }
  };
  /******************************************************************/
  /* get facutlies */
  /******************************************************************/
  const getFacultiesHandler = async () => {
    // get faculties
    const response = await getFacultiesService();
    if (response.status === "success") {
      // set faculties
      setFacultiesData(response.data);
    }
  };
  // snackbar state
  const handleCloseSnackbar = () => {
    dispatchDashboardStates({ type: "CLEAR" });
  };

  return (
    <Fragment>
      <NavHeader title={"بيانات الطلاب"} />
      <br />
      {(role === "SUPERADMIN" || role === "SUPPORT") && (
        <form className={styles["nav-input"]}>
          <div className={styles["form-control"]}>
            <select
              id="faculty"
              name="faculty"
              value={facultySelected}
              onChange={(e) => {
                setFacultySelected(e.target.value);
              }}
            >
              <option value={"اختر الكلية"}>اختر الكلية</option>
              {facultiesData.map((el) => (
                <option value={el} key={el}>
                  {el}
                </option>
              ))}
            </select>
          </div>
          {!dashboardStates.pendingLoading && (
            <BtnSmall
              title={"بحث"}
              fixedWidth={true}
              onClick={async () => {
                await getStudentsDataHandler(1);
              }}
            />
          )}
          {dashboardStates.pendingLoading && (
            <BtnSmall
              fixedWidth={true}
              title={
                <CircularProgress
                  size={20}
                  sx={{
                    color: "#a18a00",
                  }}
                />
              }
            />
          )}
        </form>
      )}
      {renderContainer && (
        <div>
          <div className={styles["students-container"]}>
            <div className={styles["infos"]}>
              <div className={styles["info"]}>
                <h3>عدد كل الطلبة</h3>
                <p>{numberOfStudents}</p>
              </div>
              <div className={styles["info"]}>
                <h3>عدد الطلبة اكملوا بيانتهم</h3>
                <p>{numberOfStudentsCompleted}</p>
              </div>
              {!dashboardStates.pendingPrinting && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {(role === "SUPERADMIN" || role === "SUPPORT") && (
                    <>
                      <BtnSmall
                        title={`${
                          role === "SUPERADMIN" ? "[دعم فنى] -> " : ""
                        } تنزيل البيانات (غير مكتمل)`}
                        onClick={exportHandler("incompleteSupport")}
                      />
                      {role === "SUPERADMIN" && (
                        <BtnSmall
                          title={`${
                            role === "SUPERADMIN" ? "[دعم فنى] -> " : ""
                          } تنزيل البيانات (مكتمل)`}
                          onClick={exportHandler("completeSupport")}
                        />
                      )}
                    </>
                  )}
                  {role === "SUPERADMIN" && (
                    <>
                      <BtnSmall
                        title={"تنزيل البيانات (غير مكتمل)"}
                        onClick={exportHandler("incomplete")}
                      />
                      <BtnSmall
                        title={"تنزيل البيانات (مكتمل)"}
                        onClick={exportHandler("complete")}
                      />
                      <BtnSmall
                        title={"تنزيل الصور (مكتمل)"}
                        onClick={exportHandler("completePhotos")}
                      />
                    </>
                  )}
                </div>
              )}
              {dashboardStates.pendingPrinting && (
                <BtnSmall
                  fixedWidth={true}
                  title={
                    <CircularProgress
                      size={20}
                      sx={{
                        color: "#a18a00",
                      }}
                    />
                  }
                />
              )}
            </div>
            <div className={styles["nav-search"]}>
              <div className={styles["search-container"]}>
                <div className={styles["form-control-special"]}>
                  <select
                    id="nationality"
                    name="nationality"
                    value={searchType}
                    onChange={(e) => {
                      setSearchType(e.target.value);
                    }}
                  >
                    <option value={"اختر نوع البحث"}>اختر نوع البحث</option>
                    {searchTypeData.map((el) => (
                      <option value={el.value} key={el.value}>
                        {el.title}
                      </option>
                    ))}
                  </select>
                </div>

                <Input
                  type="search"
                  placeholder={"اختر نوع البحث"}
                  wd="md"
                  ref={searchRef}
                >
                  اختر الكلية
                </Input>
                <BtnSmall icon={SearchIcon} onClick={searchForStudentHandler} />
                {/* check box */}
              </div>
              <div className={styles["check-box"]}>
                <input
                  type="checkbox"
                  id="check"
                  name="check"
                  value="check"
                  onChange={async (e) => {
                    if (e.target.checked) {
                      await filterIsCompletedHandler(true);
                    } else {
                      await filterIsCompletedHandler(false);
                    }
                  }}
                />
                <label htmlFor="check">اكملوا بياناتهم</label>
              </div>
            </div>
            {/* pagination */}
            {!searchMode && (
              <div className={styles["pagination-container"]}>
                <Stack spacing={2}>
                  <Pagination
                    count={numberOfPages}
                    page={pageSelected}
                    color="primary"
                    size="large"
                    dir="ltr"
                    onChange={paginationHandler}
                  />
                </Stack>
              </div>
            )}
            <StudentItem
              studentData={{
                studentName: "الاسم",
                nationalID: "الرقم القومي  ",
                phoneNumber: "رقم الهاتف",
                college: "الكلية",
                info: "حالة البيانات",
              }}
            />
            {/* student item */}
            {!dashboardStates.pendingLoading &&
              studentsData.length > 0 &&
              studentsData.map((el) => (
                <StudentItem
                  key={el.nationalID}
                  studentData={{ ...el, info: "" }}
                  onDeleteHandler={(id, name) => {
                    setStudentDeletedObj({
                      name,
                      id,
                    });
                    setConfirmDeleteForm(true);
                  }}
                />
              ))}
            {!dashboardStates.pendingLoading && studentsData.length <= 0 && (
              <Message type={"info"} text={"لا يوجد بيانات طلاب"} />
            )}
            {dashboardStates.pendingLoading && (
              <Message type={"load"} text={"يتم تحميل البيانات"} />
            )}
          </div>

          {/* pagination */}
          {!searchMode && (
            <div className={styles["pagination-container"]}>
              <Stack spacing={2}>
                <Pagination
                  count={numberOfPages}
                  page={pageSelected}
                  color="primary"
                  size="large"
                  dir="ltr"
                  onChange={paginationHandler}
                />
              </Stack>
            </div>
          )}
        </div>
      )}
      {!renderContainer && (
        <div className={styles["students-container"]}>
          <br />
        </div>
      )}
      {/* ********** open Confirmation Form  confirmDeleteForm ********** */}
      <FormPopUp open={confirmDeleteForm} handleClose={handleCloseConfirmForm}>
        <div className={styles["confirm-input"]}>
          <h2>
            هل تريد مسح <span> {studentDeletedObj.name}</span>؟
          </h2>
          <div className={styles["btns-group"]}>
            <button
              onClick={handleCloseConfirmForm}
              className={`${styles["btn"]} ${styles["normal"]}`}
            >
              لا
            </button>
            <button
              onClick={deleteStudentHandler}
              className={`${styles["btn"]} ${styles["danger"]}`}
            >
              نعم
            </button>
          </div>
        </div>
      </FormPopUp>
      {/* ********** SUCESS SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.success}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          dir="ltr"
          sx={{
            width: "100%",
            backgroundColor: "#388E3C",
            color: "#fff",
            fontSize: "1.4rem",
            "& .MuiAlert-icon": {
              color: "#fff",
            },
          }}
        >
          {dashboardStates.successMessage}!
        </Alert>
      </Snackbar>
      {/* ********** ERROR SNACKBAR ********** */}
      <Snackbar
        open={dashboardStates.error}
        onClose={handleCloseSnackbar}
        autoHideDuration={20000}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert
          severity="error"
          onClose={handleCloseSnackbar}
          dir="ltr"
          sx={{
            width: "100%",
            backgroundColor: "#D32F2F",
            color: "#fff",
            fontSize: "1.4rem",
            "& .MuiAlert-icon": {
              color: "#fff",
            },
          }}
        >
          !{dashboardStates.errorMessage}
        </Alert>
      </Snackbar>
    </Fragment>
  );
});

export { StudentsInfo };
